import { Button, Divider, HStack, Text } from "@chakra-ui/react";
import MyIcon from "../../../components/Icon/MyIcon";
import { colors } from "../../../styles";

interface IFileAttachProps {
    label: string;
    inputId: string;
    file: File | null;
    onChange: (file: File | null) => void;
    showDivider?: boolean;
}

export default function FileAttach({
    label,
    inputId,
    file,
    onChange,
    showDivider = false,
}: IFileAttachProps) {
    const clearInput = () => {
        const inputElement = document.getElementById(inputId) as HTMLInputElement | null;
        if (inputElement) inputElement.value = "";
    };

    return (
        <>
            {showDivider && <Divider marginY={2.5} />}
            <HStack width="100%" justifyContent="space-between" alignItems="center">
                <Text fontSize={16} fontWeight={700} color={colors.g1}>
                    {label}
                </Text>
                <input
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    id={inputId}
                    onChange={(event) => {
                        const nextFile = event.target.files?.[0] ?? null;
                        onChange(nextFile);
                    }}
                />
                <Button
                    type="button"
                    variant="outline"
                    color={colors.g1}
                    size="sm"
                    onClick={() => document.getElementById(inputId)?.click()}
                    marginLeft={2}
                >
                    사진첨부
                </Button>
            </HStack>
            {file && (
                <HStack width="100%" justifyContent="space-between" alignItems="center" marginTop={4}>
                    <HStack>
                        <MyIcon src="svg/photo.svg" alt="photo" width={20} height={20} />
                        <Text fontSize={14} fontWeight={500} color={colors.link}>
                            {file.name}
                        </Text>
                    </HStack>
                    <MyIcon
                        src="svg/delete-line.svg"
                        alt="delete"
                        width={20}
                        height={20}
                        onClick={() => {
                            onChange(null);
                            clearInput();
                        }}
                    />
                </HStack>
            )}
        </>
    );
}
